import styled from "styled-components";
import { hex2rgba } from "../../../../../../utils/styles";

export const ChatListStyled = styled.ul`
    
`;

export const ChatItemStyled = styled.li`
    display: flex;
    padding: 15px 20px 0 20px;
    background-color: ${({ theme, active }) => active && hex2rgba(theme.colors.lightBlue, 0.1)};
    cursor: pointer;
    transition: background-color 0.3s;
    :hover {
        background-color: ${({ theme, active }) => !active && hex2rgba(theme.colors.lightBlue, 0.05)};
    }
`;